import '@department-of-veterans-affairs/component-library/dist/main.css';
import {
  defineCustomElementVaAdditionalInfo,
  defineCustomElementVaAlert,
  defineCustomElementVaButton,
  defineCustomElementVaButtonPair,
  defineCustomElementVaCheckbox,
  defineCustomElementVaCheckboxGroup,
  defineCustomElementVaMemorableDate,
  defineCustomElementVaModal,
  defineCustomElementVaPrivacyAgreement,
  defineCustomElementVaRadio,
  defineCustomElementVaRadioOption,
  defineCustomElementVaSegmentedProgressBar,
  defineCustomElementVaSelect,
  defineCustomElementVaTextarea,
  defineCustomElementVaTextInput,
} from '@department-of-veterans-affairs/component-library/dist/components';

defineCustomElementVaAdditionalInfo();
defineCustomElementVaAlert();
defineCustomElementVaButton();
defineCustomElementVaButtonPair();
defineCustomElementVaCheckbox();
defineCustomElementVaCheckboxGroup();
defineCustomElementVaMemorableDate();
defineCustomElementVaModal();
defineCustomElementVaPrivacyAgreement();
defineCustomElementVaRadio();
defineCustomElementVaRadioOption();
defineCustomElementVaSegmentedProgressBar();
defineCustomElementVaSelect();
defineCustomElementVaTextarea();
defineCustomElementVaTextInput();
